import { Component, Input, OnInit } from '@angular/core';
import { AlertType } from '../../enums/alert-type.enum';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements OnInit {
  @Input() type: AlertType;
  @Input() message: string;

  constructor() {}

  ngOnInit(): void {}
}
